class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm.id === 'FacetFiltersFormMobile') {
      facetForm.addEventListener('submit', this.onSubmitHandler.bind(this));
    } else {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer')?.querySelector('.collection')?.classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        (FacetFiltersForm.filterData ||= []).push({ html, url });
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const cachedFilter = FacetFiltersForm.filterData.find(filterDataUrl);
    if (!cachedFilter) return;

    const html = cachedFilter.html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const parsedHTML = FacetFiltersForm.parseHTML(html);
    const source = parsedHTML.getElementById('ProductGridContainer');
    const destination = document.getElementById('ProductGridContainer');

    if (!source || !destination) return;
    destination.innerHTML = source.innerHTML;
  }

  static renderProductCount(html) {
    const parsedHTML = FacetFiltersForm.parseHTML(html);
    const sourceCount = parsedHTML.getElementById('ProductCount');
    const sourceCountDesktop = parsedHTML.getElementById('ProductCountDesktop');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (container && sourceCount) {
      container.innerHTML = sourceCount.innerHTML;
      container.classList.remove('loading');
    }

    if (containerDesktop && sourceCountDesktop) {
      containerDesktop.innerHTML = sourceCountDesktop.innerHTML;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = FacetFiltersForm.parseHTML(html);
    const currentFilters = document.getElementById('main-collection-filters');
    const newFilters = parsedHTML.getElementById('main-collection-filters');
    const currentFilter = event?.target?.closest('.js-filter');
    // ------------TD CHANGE-----------
    const activeElementId = currentFilters?.contains(document.activeElement) ? document.activeElement.id : null;
    // ------------ END TD CHANGE-----------
    const openDesktopAccordions = currentFilters
      ? Array.from(currentFilters.querySelectorAll('#FacetFiltersForm .td-accordion__item.is-active')).map((item) => item.dataset.item)
      : [];

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');

    if (!facetDetailsElements.length) {
      if (currentFilters && newFilters) {
        currentFilters.innerHTML = newFilters.innerHTML;
      }
      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);
      FacetFiltersForm.restoreDesktopAccordionState(openDesktopAccordions);
      // ------------TD CHANGE-----------
      FacetFiltersForm.restoreFocus(activeElementId);
      // ------------ END TD CHANGE-----------
      return;
    }

    const matchesIndex = (element) => {
      return currentFilter ? element.dataset.index === currentFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.restoreDesktopAccordionState(openDesktopAccordions);
    // ------------TD CHANGE-----------
    FacetFiltersForm.restoreFocus(activeElementId);
    // ------------ END TD CHANGE-----------

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, currentFilter);
  }

  // ------------TD CHANGE-----------
  static restoreFocus(elementId) {
    if (!elementId) return;
    document.getElementById(elementId)?.focus({ preventScroll: true });
  }
  // ------------ END TD CHANGE-----------

  static restoreDesktopAccordionState(openItems = []) {
    if (!openItems.length) return;

    const filtersContainer = document.getElementById('main-collection-filters');
    filtersContainer?.classList.add('facets-restoring');

    document.querySelectorAll('#FacetFiltersForm .td-accordion__item').forEach((item) => {
      if (!openItems.includes(item.dataset.item)) return;

      const toggle = item.querySelector('.td-accordion__toggle');
      const content = item.querySelector('.td-accordion__content');
      item.classList.add('is-active');
      toggle?.setAttribute('aria-expanded', 'true');

      if (content) {
        if (content.hideTimer) clearTimeout(content.hideTimer);
        content.hidden = false;
        content.style.maxHeight = `${content.scrollHeight}px`;
      }
    });

    requestAnimationFrame(() => {
      filtersContainer?.classList.remove('facets-restoring');
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!activeFacetsElement || !target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!source || !target) return;
      target.innerHTML = source.innerHTML;
    });

    const mobileFacetForm = document.getElementById('FacetFiltersFormMobile');
    mobileFacetForm?.closest('menu-drawer')?.bindEvents();
    document.querySelectorAll('accordion-wrapper').forEach((accordion) => {
      accordion.items = accordion.querySelectorAll('.td-accordion__item');
      accordion.bindEvents?.();
    });
  }

  static renderCounts(source, target) {
    if (!source || !target) return;

    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return [];

    return [
      {
        section: productGrid.dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const form = event.currentTarget || event.target.closest('form');
    const isMobile = form?.id === 'FacetFiltersFormMobile';

    if (isMobile && form) {
      const searchParams = this.createSearchParams(form);
      form.closest('menu-drawer')?.querySelector('summary')?.click();
      this.onSubmitForm(searchParams, null);
      return;
    }

    const forms = [];
    sortFilterForms.forEach((sortFilterForm) => {
      if (
        sortFilterForm.id === 'FacetSortForm' ||
        sortFilterForm.id === 'FacetFiltersForm' ||
        sortFilterForm.id === 'FacetSortDrawerForm'
      ) {
        const noJsElements = document.querySelectorAll('.no-js-list');
        noJsElements.forEach((el) => el.remove());
        forms.push(this.createSearchParams(sortFilterForm));
          }
    });
    this.onSubmitForm(forms.join('&'), event)
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (!facetLink) return;
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetsButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      this.toggleFacets(event);
    });
    // ------------TD CHANGE-----------
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.toggleFacets(event);
    });
    // ------------ END TD CHANGE-----------
  }

  // ------------TD CHANGE-----------
  connectedCallback() {
    this.syncState();
  }

  syncState() {
    const facetsId = this.dataset.facetsId;
    const facets = document.querySelector(`[data-facet-wrapper-id="${facetsId}"]`);
    if (!facets) return;

    const expanded = facets.classList.contains('facets-vertical--open');
    const label = this.querySelector(expanded ? '.facet__button--close' : '.facet__button--open')?.textContent.trim();
    this.classList.toggle('facet__button--open', expanded);
    this.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (label) this.setAttribute('aria-label', label);
  }
  // ------------ END TD CHANGE-----------

  toggleFacets() {
    const facetsId = this.dataset.facetsId;
    const facets = document.querySelector(`[data-facet-wrapper-id="${facetsId}"]`);
    if (!facets) return;
    facets.classList.toggle('facets-vertical--open');
    // ------------TD CHANGE-----------
    this.syncState();
    // ------------ END TD CHANGE-----------
  }
}

customElements.define('facets-button', FacetsButton);
